import { ColumnTable } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { Announcement } from '../types';
import dayjs from 'dayjs';

export const useColumns = () => {
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_ANNOUNCEMENTS_LIST,
  );

  const columns = useMemo<ColumnTable<Announcement>[]>(
    () => [
      {
        headerText: t(`table.title`),
        tdClassName: 'text-center fw-700',
        thClassName: 'text-center',
        columnName: 'title',
        width: 190,
      },
      {
        headerText: t(`table.publishAt`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'publishAt',
        width: 190,
        cellFormat({ value }) {
          return value ? dayjs(value).format('DD/MM/YYYY') : 'N/D';
        },
      },
      {
        headerText: t(`table.validUntilAt`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'validUntilAt',
        width: 190,
        cellFormat({ value }) {
          return value ? dayjs(value).format('DD/MM/YYYY') : 'N/D';
        },
      },
    ],
    [t],
  );
  return columns;
};
